module.exports = __webpack_public_path__ + "static/img/mini_portada_manual.59d26276.png";